// src/components/Hero.js (VERSÃO ATUALIZADA COM i18n)
import React from 'react';
import { useTranslation } from 'react-i18next'; // 👈 Importamos o Hook

function Hero() {
  const { t } = useTranslation(); // 👈 Inicializamos o Hook de tradução

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  return (
    <section className='hero about-with-dots'>
      <div className='dots-background'></div>

      <div className='hero-container'>
        {/* Usamos a função t() para buscar a chave 'hero_title' */}
        <h1>{t('hero_title')}</h1>
        <p className='hero-subtitle'>
          {/* Usamos a função t() para buscar a chave 'hero_subtitle' */}
          {t('hero_subtitle')}
        </p>
        <button className='cta-button' onClick={scrollToContact}>
          <i className='fas fa-phone'></i>
          {/* Usamos a função t() para buscar a chave 'cta_contact_button' */}
          {t('cta_contact_button')}
        </button>
      </div>
    </section>
  );
}

export default Hero;
